import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid var(--glass-border);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const Title = styled.h3`
  font-size: 18px;
  color: var(--text-primary);
  margin: 0;
`;

const Count = styled.span`
  background: var(--glass-2);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: var(--text-primary);
  border: 1px solid var(--glass-border);
`;

const CommentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const CommentItem = styled.div`
  display: flex;
  gap: 15px;
  background: var(--glass-1);
  padding: 20px;
  border-radius: var(--radius-sm, 12px);
  border: 1px solid rgba(255,255,255,0.03);
`;

const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
`;

const Body = styled.div`
  flex: 1;
`;

const Author = styled.div`
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
  margin-bottom: 4px;
`;

const DateText = styled.div`
  font-size: 11px;
  color: var(--text-muted);
  margin-bottom: 8px;
`;

const Text = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.5;
`;

const InputBox = styled.div`
  margin-top: 30px;
  background: var(--glass-1);
  padding: 20px;
  border-radius: var(--radius-sm, 12px);
  border: 1px dashed var(--glass-border);
`;

const Textarea = styled.textarea`
  width: 100%;
  background: var(--glass-2);
  border: 1px solid var(--glass-border);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 12px;
  min-height: 80px;
  margin-bottom: 15px;
  outline: none;
  font-family: inherit;
`;

const Button = styled.button`
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: bold;
  cursor: pointer;
`;

const CommentsWidget = ({ node }) => {
  return (
    <Wrapper width={node.style?.desktop?.width}>
      <Header>
        <Title>Kommentare</Title>
        <Count>2 Antworten</Count>
      </Header>

      <CommentList>
        <CommentItem>
          <Avatar>JS</Avatar>
          <Body>
            <Author>Julian Sommer</Author>
            <DateText>Gestern um 14:30 Uhr</DateText>
            <Text>Sehr guter Artikel, das hat mir extrem bei unserem 5G Setup geholfen!</Text>
          </Body>
        </CommentItem>
        <CommentItem>
          <Avatar>AM</Avatar>
          <Body>
            <Author>Anna Müller</Author>
            <DateText>Heute um 09:15 Uhr</DateText>
            <Text>Wann kommt das nächste Update zu diesem Produkt-Stack?</Text>
          </Body>
        </CommentItem>
      </CommentList>

      <InputBox>
        <Author style={{marginBottom: 10}}>Hinterlasse eine Antwort</Author>
        <Textarea placeholder="Schreibe einen Kommentar..." />
        <Button className="tef-bubbles">Senden</Button>
      </InputBox>
    </Wrapper>
  );
};

registry.register('post_comments', {
  label: 'Kommentar Block',
  icon: '🗨️',
  category: 'dynamic',
  defaultContent: {},
  defaultStyle: { desktop: { width: '100%' } },
  render: CommentsWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Hinweis', fields: [{name:'info', label:'Dynamisch', type:'text', readOnly:true}] }] },
    { tab: 'style', groups: [{ title: 'Container', fields: [{name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
